module.exports = "\n  <nav class=\"c-pagination\" v-if=\"items.total_pages > 1\">\n  \t<ul class=\"c-pagination__list h-list\">\n  \t\t<li class=\"c-pagination__item\" v-bind:class=\"{ 'is-active': isActive(n) }\" v-for=\"n in items.total_pages\">\n  \t\t\t<a href=\"#\" v-on:click.prevent=\"paginate(n)\" class=\"c-pagination__link\">{{n}}</a>\n  \t\t</li>\n  \t</ul>\n  </nav>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/scripts/components/pagination.vue
// module id = 173
// module chunks = 8 9